import './style.scss';

export function our_vision_block() {
  const block = document.querySelector('.our_vision_block');
  if (!block) return;
  
}
